/* Copyright (c) 2023 Xperi. All Rights Reserved.  */

export class QoEStreamingProtocolType {
    static DASH = 'DASH';

    static HLS = 'HLS';

    static SMOOTH_STREAMING = 'SMOOTH_STREAMING';

    static UNKNOWN = 'Unknown';
}
